(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pt-header"]) return;
  try {
    
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.menu-panel[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}});
  document.addEventListener('click',event=>{document.querySelectorAll('.menu-panel[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-product"]) return;
  try {
    
  document.addEventListener('change',event=>{if(!event.target.matches('[data-variant-select]'))return;const select=event.target;const section=select.closest('.product-layout');section.querySelector('[data-product-price]').textContent=select.selectedOptions[0].dataset.price;const url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.history.replaceState({},'',url);});

  } catch(e) { console.error(e); }
})();
})();
